import { gql } from '@apollo/client';

export const DELETE_CREW_MEMBER_ABSENCE = gql`
	mutation deleteAbsence($id: ID!) {
		deleteCrewMemberAbsence(id: $id) {
			... on CrewMemberAbsenceErrorResponse {
				errors
			}
			... on CrewMemberAbsenceSuccessResponse {
				absence {
					id
				}
			}
			... on CrewMemberAbsenceConflictingWorkAssignmentsResponse {
				workAssignments {
					id
				}
				absences {
					id
				}
			}
		}
	}
`;
